import { fetchOptions, generateCalendarDatesEndpoint, queryKeyFactory } from '@alluradirect/react';
import { httpsUrl } from 'config/url';
import { useQuery } from 'react-query';

const queryFn = async (propertyId: number, startDate: string, endDate: string) => {
  const endpoint = `${httpsUrl()}${generateCalendarDatesEndpoint({ propertyId, startDate, endDate })}`;

  try {
    const response = await fetch(endpoint, {
      ...fetchOptions,
    });

    if (!response.ok) {
      throw new Error('You Have an Error ' + response.url);
    }

    const data = await response.json();

    return { startDate, endDate, dates: data.DATA.DATES };
  } catch (e: unknown) {
    throw new Error(e as any);
  }
};

export const propertyCalendarDatesQueryKeyFactory = queryKeyFactory('calendar-dates');

export const usePropertyCalendarDates = (
  propertyId: number,
  startDate: string,
  endDate: string,
  enabled = true,
  refetchOnWindowFocus: boolean | 'always' = true
) => {
  const queryKey = [...propertyCalendarDatesQueryKeyFactory.detail(String(propertyId)), startDate, endDate];

  return useQuery<any, Error>({
    queryFn: () => queryFn(propertyId, startDate, endDate),
    queryKey,
    refetchOnWindowFocus,
    useErrorBoundary: true,
    enabled,
    keepPreviousData: true,
  });
};
